<template>
	<v-app-bar
		class="topBar"
		app
		scroll-off-screen
	>
		<v-btn
			v-show="parentRoute"
			icon
			@click="gotoParentRoute"
		>
			<v-icon>mdi-arrow-left</v-icon>
		</v-btn>
		<v-spacer></v-spacer>
		<v-img
			class="logo"
			height="38"
			src="@/assets/logo.svg"
			contain
		/>
		<v-spacer></v-spacer>
		<v-btn
			icon
			@click="$emit('menuButtonClick')"
		>
			<v-icon>mdi-menu</v-icon>
		</v-btn>
		<v-toolbar-title
			v-if="$route.meta && $route.meta.headline"
			slot="extension"
		>
			{{$route.meta.headline}}
		</v-toolbar-title>
	</v-app-bar>
</template>

<script>

export default {
	name: 'TopBar',
	computed: {
		parentRoute () {
			if (this.$route.matched.length > 1) {
				return this.$route.matched[this.$route.matched.length - 2]
			} else {
				return null
			}
		}
	},
	methods: {
		gotoParentRoute () {
			if (this.parentRoute) {
				let scrollTo = 0;

				// If parent route was scrolled, store the position
				if (this.parentRoute.meta.scrollTop) {
					scrollTo = this.parentRoute.meta.scrollTop
					this.parentRoute.meta.scrollTop = null
				}

				// Navigate to parent route
				if (this.parentRoute.redirect) {
					this.$router.replace(this.parentRoute.redirect)
				} else {
					this.$router.replace({
						name: this.parentRoute.name,
					})
				}

				// If parent route was scrolled, scroll to that position
				// Otherwise scroll to top
				this.$nextTick(() => {
					if (scrollTo) {
						window.scrollTo(0, scrollTo)
					} else {
						window.scrollTo(0, 0)
					}
				})

				return true
			} else {
				return false
			}
		}
	},
}
</script>

<style lang="scss" scoped>

	.logo {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
	}

</style>